import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import styles from './Tree/components/TreeItem/TreeItem.module.css';
import { AccountTree, AutoAwesome, AutoAwesomeMotion, CalendarMonth, CalendarViewDay, Colorize, ContentCopy, Dashboard, DeveloperBoard, EditCalendar, EmojiEvents, Favorite, FolderCopy, FormatAlignLeft, FormatListNumbered, FormatListNumberedRtl, Groups, Groups2, Help, History, Home, HourglassBottom, Hub, ImportExport, Inventory, Inventory2, LockClock, Login, Logout, ManageAccounts, ManageSearch, Pages, Palette, People, Person, PersonPin, Phone, Polyline, PrecisionManufacturing, Psychology, PsychologyAlt, PsychologyAltOutlined, PsychologyAltRounded, PsychologyAltSharp, PsychologyAltTwoTone, PunchClock, QueryStats, Rule, Search, Settings, SmartToy, Speed, Timer, Timer10Outlined, TimerOutlined, VerticalSplit, VerticalSplitOutlined, ViewList, Watch, Workspaces } from '@mui/icons-material';

export default function IconLabelTabs({tabValue, setTabValue}) {
  // const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      {/* Shamelessly including some design work here through comments!! */}

      {/* <Tabs className={styles.Tabs} value={value} onChange={handleChange} aria-label="Top-level icon label tabs example"> */}
        {/* SYSTEM LEVEL */}
          {/* <Tab icon={<TAOIS PIC />} label="TAOIS" /> */}
          {/* <Tab icon={<Home />} label="HOME" /> */}
          {/* <Tab icon={<Dashboard />} label="DASHBOARD" /> */}
          {/* <Tab icon={<Workspaces />} label="WORKSPACE" /> */}
          {/* (CURRENT(?)) CONTEXT */}
            {/* SEARCH/OMNIBAR */}
            {/* BACK(?) */}
            {/* FORWARD(?) */}
            {/* <Tab icon={<Search />} label="SEARCH" /> */}
            {/* Execute Search Button */}
            {/* Add Item Button ...*/}
              {/* Add Task Button*/}
              {/* Add Project Button*/}
              {/* etc.*/}
          {/* <Tab icon={<Help />} label="SUPPORT" /> */}
          {/* THE FULL DATE & TIME */}
          {/* STOPWATCH TIME (Maybe) */}
          {/* TIMER/POMADORA TIMER TIME (Maybe) */}

      {/* </Tabs> */}
      {/* <Tabs className={styles.Tabs} value={value} onChange={handleChange} aria-label="Workspace icon label tabs example"> */}

        {/* Left hand menu bar/Top-level Workspace nodes */}
        {/* <Tab icon={<Settings />} label="SETTINGS" /> */}
        {/* <Tab icon={<ImportExport />} label="DATA" /> */}
        {/* <Tab icon={<Home />} label="HOME" /> (Maybe) */}
        {/* <Tab icon={<Dashboard />} label="DASHBOARD" (Maybe)/> */}
        {/* // <Tab icon={<Search />} label="SEARCH" (Maybe)/> */}

        {/* Left hand menu bar/Top-level Workspace nodes */}
        {/* // <Tab icon={<FormatAlignLeft />} label="TASKS & GOALS" /> */}
        {/* <Tab icon={<FolderCopy />} label="PROJECTS" /> */}
        {/* <Tab icon={<AccountTree />} label="SYSTEMS" /> */}
        {/* <Tab icon={<People />} label="COLLABORATION" /> */}
        {/* <Tab icon={<PrecisionManufacturing />} label="AUTOMATION" /> */}
        {/* <Tab icon={<QueryStats />} label="ANALYSIS" /> */}
        {/* <Tab icon={<ContentCopy />} label="WIKI" /> */}
        {/* <Tab icon={<History />} label="HISTORY" /> */}

      {/* </Tabs> */}
            {/* <Box
              component="BottomTabControlPanel"
              sx={{
                display: { xs: 'block', md: 'none' },
                position: 'fixed',
                bottom: 125, // Shifts up on mobile to avoid overlapping your AppLayout BottomNav!
                // left: -30,
                // minwidth: 200,
                width: 400,
                // maxWidth: 700,
                zIndex: 1050,
              }}
            > */}
      <Tabs className={styles.Tabs} 
            value={tabValue} 
            onChange={handleChange} 
            aria-label="Tasks & Goals label tabs example"
            variant="scrollable"
            allowScrollButtonsMobile
            scrollButtons="auto"
            sx={{
              width: '90%',               // 4. Forces the bar to fill its parent container width
              '& .MuiTab-root': {
                // minWidth: 'auto',          // 5. Keeps our custom shrinking rules intact
                flexInitial: 1,
                // padding: '6px 12px',
              }
            }}>

        {/* TASKS Category (or possibly GOALS & TASKS */}
        <Tab icon={<FormatAlignLeft fontSize='small'/>} label="LIST"  />
        <Tab icon={<AccountTree fontSize='small'/>} label="GRAPH" />
        <Tab icon={<ViewList fontSize='small'/>} label="TABLE" />
        <Tab icon={<VerticalSplitOutlined fontSize='small'/>} label="SCHEDULER" />
        <Tab icon={<CalendarMonth fontSize='small'/>} label="CALENDAR" />
        {/* <Tab icon={<Rule />} label="REVIEW" /> */}

      </Tabs>
      {/* </Box> */}

      {/* <Tabs className={styles.Tabs} value={tabValue} onChange={handleChange} aria-label="User icon label tabs example"> */}

        {/* USER */}
        {/* <Tab icon={<TimerOutlined />} label="TIMING" />
        <Tab icon={<HourglassBottom />} label="TIMER" />
        <Tab icon={<PsychologyAltOutlined />} label="STATUS" /> */}
        
        {/* <Tab icon={<Person />} label="USER" /> */}
        {/* <Tab icon={<Rule />} label="REVIEW" /> */}
        {/* <Tab icon={<Settings />} label="CONFIGURATION" /> */}
          {/* <Tab icon={<Watch/>} label="HOURS" /> */}
          {/* <Tab icon={<Palette />} label="CUSTOMIZATION" />           */}
          {/* <Tab icon={<ImportExport />} label="DATA" ('USER DATA' Maybe)/> */}
        {/* <Tab icon={<People />} label="CONNECTIONS" /> */}
          {/* <Tab icon={<People />} label="Contacts" (Maybe)/> */}
        {/* <Tab icon={<PrecisionManufacturing />} label="AUTOMATION" /> */}
        {/* <Tab icon={<QueryStats />} label="ANALYSIS" /> */}
        {/* <Tab icon={<ContentCopy />} label="WIKI" />         */}
        {/* <Tab icon={<History />} label="HISTORY" /> */}
        
        {/* <Tab icon={<Login/>} label="Log-In" /> */}
        {/* <Tab icon={<Logout/>} label="Log-Out" /> */}

      {/* </Tabs> */}
    </>
  );
}